import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix per le icone di Leaflet in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// Icona personalizzata Energy - VERDE
const energyIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const API_URL = '';

const AgencyMap = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await fetch(`${API_URL}/api/public/locations`);
        if (!response.ok) throw new Error('Errore nel caricamento');
        const data = await response.json();
        setLocations(data.locations || []);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching locations:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  // Centro Italia
  const italyCenter = [41.8719, 12.5674];
  const defaultZoom = 6;

  if (loading) {
    return (
      <div className="w-full h-[400px] bg-slate-900/50 rounded-xl flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin w-8 h-8 border-2 border-cyan-500 border-t-transparent rounded-full mx-auto mb-3"></div>
          <p className="text-slate-400">Caricamento mappa...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-[400px] bg-slate-900/50 rounded-xl flex items-center justify-center">
        <p className="text-red-400">Errore: {error}</p>
      </div>
    );
  }

  return (
    <div className="w-full rounded-xl overflow-hidden border border-slate-700/50 shadow-xl">
      <MapContainer
        center={italyCenter}
        zoom={defaultZoom}
        scrollWheelZoom={false}
        style={{ height: '450px', width: '100%' }}
        className="z-0"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
        {locations.map((loc, index) => (
          <Marker 
            key={`${loc.city}-${index}`} 
            position={[loc.lat, loc.lng]}
            icon={energyIcon}
          >
            <Popup className="energy-popup">
              <div className="text-center p-1">
                <h3 className="font-bold text-gray-900 text-sm">{loc.name}</h3>
                <p className="text-gray-600 text-xs mt-1">{loc.city}</p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      
      {/* Legend */}
      <div className="bg-slate-900/90 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
          <span className="text-sm text-slate-300">Agenzie Energy Multiservizi operative</span>
        </div>
        <span className="text-xs text-slate-500">{locations.length} sedi in Italia</span>
      </div>
    </div>
  );
};

export default AgencyMap;
